<template>
    <div>
        <div id="main" style="height:500px;width:100%;margin: 80px;"></div>
        <div id="main1" style="height:500px;width:100%;margin: 80px;"></div>
        <div id="main2" style="height:500px;width:100%;margin: 80px;"></div>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2021-12-14 09:52:28

import * as echarts from 'echarts';
import emCommonApiMixin from "@/mixin/em/common/api";

export default {
    name: "sithMesStoolKpiList",
    mixins: [emCommonApiMixin],
    data() {
        return {
            emptyDateCounts: [],
            pastDateCounts: [],
            purchaseGroups: [],
            pastDateCountList: [],
            halfMonthCounts: [],
            monthCounts: [],
            twoMonthCounts: [],
            dateList: [],
            purchaseGroupList: [],
            lineList: []
        }
    },
    props: {},
    computed: {},
    methods: {

        getTodayCount() {

            let url = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/getTodayCount";
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    this.emptyDateCounts = response.data.emptyDateCounts;
                    this.pastDateCounts = response.data.pastDateCounts;
                    this.purchaseGroups = response.data.purchaseGroups;
                    this.initToday();
                })

        },
        getTrendData() {

            let url = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPo/getTrendData";
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    this.dateList = response.data.dateList;
                    let listMap = response.data.listMap;
                    for (let key in listMap) {
                        this.purchaseGroupList.push(key);
                        this.lineList.push(
                            {
                                name: key,
                                data: listMap[key],
                                type: 'line',
                                smooth: true,
                                emphasis: {
                                    focus: 'series'
                                },
                                label: {
                                    show: true
                                }
                            });
                    }
                    this.initTrend();
                })
        },
        getPrCount() {

            let url = this.$store.state.sithMesStoolPo.baseModuleUrl + "/sithMesStoolPr/initPrKpi";
            this.$_emApiMixin_post(url, {})
                .then(response => {
                    this.halfMonthCounts = response.data.halfMonthCounts;
                    this.monthCounts = response.data.monthCounts;
                    this.twoMonthCounts = response.data.twoMonthCounts;
                    this.purchaseGroups = response.data.purchaseGroups;
                    this.initPrKpi();
                })

        },
        initToday() {
            let chartDom = document.getElementById('main');
            let myChart = echarts.init(chartDom);

            let option = {
                title: {
                    text: '当天confirmation情况'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['日期为空', '日期为过去']
                },
                toolbox: {
                    show: true,
                    feature: {
                        magicType: {show: true, type: ['line', 'bar']},
                        saveAsImage: {show: true}
                    }
                },
                calculable: true,
                xAxis: [
                    {
                        type: 'category',
                        data: this.purchaseGroups
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: [
                    {
                        name: '日期为空',
                        type: 'bar',
                        data: this.emptyDateCounts
                    },
                    {
                        name: '日期为过去',
                        type: 'bar',
                        data: this.pastDateCounts
                    }
                ]
            };

            myChart.setOption(option);
        },
        initTrend() {
            let chartDom = document.getElementById('main1');
            let myChart = echarts.init(chartDom);

            let option = {

                title: {
                    text: 'Confirmation在过去近期情况'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    data: this.purchaseGroupList
                },
                toolbox: {
                    show: true,
                    feature: {
                        magicType: {show: true, type: ['line', 'bar']},
                        saveAsImage: {show: true}
                    }
                },
                calculable: true,
                xAxis: {
                    type: 'category',
                    data: this.dateList
                },
                yAxis: {
                    type: 'value'
                },
                series: this.lineList
            };

            option && myChart.setOption(option);
        },
        initPrKpi() {
            let chartDom = document.getElementById('main2');
            let myChart = echarts.init(chartDom);

            let option = {

                title: {
                    text: 'PR的KPI分析'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['半个月', '一个月', '两个月']
                },
                toolbox: {
                    show: true,
                    feature: {
                        magicType: {show: true, type: ['line', 'bar']},
                        saveAsImage: {show: true}
                    }
                },
                calculable: true,
                xAxis: {
                    type: 'category',
                    data: this.purchaseGroups
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    name: '半个月',
                    type: 'bar',
                    data: this.halfMonthCounts
                },
                    {
                        name: '一个月',
                        type: 'bar',
                        data: this.monthCounts
                    },
                    {
                        name: '两个月',
                        type: 'bar',
                        data: this.twoMonthCounts
                    }]
            };

            option && myChart.setOption(option);
        }
    },
    mounted() {

        this.getTodayCount();
        this.getTrendData();
        this.getPrCount();


    }
};
</script>